<template>
  <Modal v-model="open" :title="title">
    <Form
      ref="formItem"
      :model="formItem"
      :label-width="80"
      :rules="ruleValidate"
    >
      <FormItem label="车辆名称" prop="car_name">
        <Input
          v-model="formItem.car_name"
          placeholder="请输入车辆名称"
          clearable
        />
      </FormItem>
      <FormItem label="计费价格" prop="car_price">
        <Input
          v-model="formItem.car_price"
          type="number"
          placeholder="请输入计费价格"
          clearable
        />
      </FormItem>
      <FormItem label="车辆描述" prop="car_desc">
        <Input
          v-model="formItem.car_desc"
          placeholder="请输入车辆描述"
          clearable
        />
      </FormItem>
      <FormItem label="车辆标识" prop="car_ref">
        <Input
          v-model="formItem.car_ref"
          placeholder="请输入车辆标识"
          clearable
        />
      </FormItem>
    </Form>
    <div slot="footer" style="text-align: center">
      <Button @click="cancel('formItem')">关闭</Button>
      <Button type="primary" :loading="loading" @click="ok('formItem')">
        提交
      </Button>
    </div>
  </Modal>
</template>
<script>
import { CarAdd, CarEdit } from '@/api/car'

export default {
  name: 'AreaAddUpdate',
  data() {
    return {
      formItem: {
        car_name: '',
        car_price: '',
        car_desc: '',
        car_ref: '',
        area_id: ''
      },
      ruleValidate: {
        car_name: [
          { required: true, message: '请输入车辆名称', trigger: 'blur' },
        ],
        car_price: [
          { required: true, message: '请输入计费价格', trigger: 'blur' },
        ],
        car_desc: [
          { required: true, message: '请输入车辆描述', trigger: 'blur' },
        ],
        car_ref: [
          { required: true, message: '请输入车辆标识', trigger: 'blur' },
        ],
      },
      open: false,
      title: '添加车辆',
      loading: false,
    }
  },
  methods: {
    init(params) {
      console.log(params)
      if (params._id) {
        this.title = '修改车辆'
        this.formItem = {
          ...params,
          car_name: params.carname || params.car_name,
          car_price: params.carprice || params.car_price,
          car_desc: params.cardesc || params.car_desc,
          car_ref: params.carref || params.car_ref,
          area_id: params.areaId || params.area_id
        }
      } else {
        this.title = '添加车辆'
        this.formItem = {
          car_name: '',
          car_price: '',
          car_desc: '',
          car_ref: '',
          area_id: params.areaId || params.area_id
        }
      }
      this.open = true
    },

    ok(name) {
      this.$refs[name].validate((valid) => {
        if (!valid) return
        const postData = JSON.parse(JSON.stringify(this.formItem))
        if (this.formItem._id) {
          CarEdit(postData)
            .then((res) => {
              if (res.data.code === 200) {
                this.$Message.success('车辆修改成功')
                this.cancel('formItem')
                this.$emit('reload')
              } else {
                this.$Message.error(res.data.msg)
              }
            })
            .catch((err) => {
              this.$Message.error(err)
            })
        } else {
          CarAdd(postData)
            .then((res) => {
              if (res.data.code === 200) {
                this.$Message.success('车辆添加成功')
                this.cancel('formItem')
                this.$emit('reload')
              } else {
                this.$Message.error(res.data.msg)
              }
            })
            .catch((err) => {
              this.$Message.error(err)
            })
        }
      })
    },

    cancel(name) {
      this.formItem = {
        car_name: '',
        car_price: '',
        car_desc: '',
        car_ref: '',
        area_id: ''
      }
      this.$refs[name].resetFields()
      this.open = false
    }
  }
}
</script>
